<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_288_20975)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.1807 27.379C9.1846 27.3831 9.18852 27.3871 9.19245 27.3912C9.48927 27.6956 9.85524 27.8858 10.2385 27.9619C10.3124 27.9766 10.3869 27.987 10.4616 27.9932C11.0336 28.0406
          11.6214 27.8399 12.0589 27.3912C12.0637 27.3863 12.0685 27.3813 12.0732 27.3763L31.4064 7.54848C32.1979 6.73672 32.1979 5.42059 31.4064 4.60882C30.6149 3.79706 29.3316 3.79706
          28.5401 4.60882L10.6257 22.9816L3.45994 15.6326C2.66843 14.8208 1.38514 14.8208 0.593632 15.6326C-0.197878 16.4443 -0.197877 17.7605 0.593633 18.5722L9.1807 27.379Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_288_20975">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
